import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from '../shared/services/auth.service';
import { ApiService } from '../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatosDenuncia } from 'src/app/shared/models/datosDenuncia';
import { Usuarios } from '../dashboard/models/usuarios';
import { PlazosDenuncia } from '../model/plazosDenuncia';
import { environment } from 'src/environments/environment.prod';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-add-investigator',
  templateUrl: './add-investigator.component.html',
  styleUrls: ['./add-investigator.component.css']
})
export class AddInvestigatorComponent implements OnInit {
  assetsUrl: string = environment.baseAssetsUrl;
  validatingForm: FormGroup;
  IsHiddenForm: boolean = false;
  @Input() denuncia: DatosDenuncia;
  investigadores: Usuarios[];
  inves_select: Usuarios[];
  plazos: PlazosDenuncia[];
  investigadorF: string = '';
  plazoFaseInvestigacionF: string = '';
  plazoFaseDecisorF: string = '';
  plazoFaseComplianceF: string = '';
  cargado: boolean = false;

  diasinves: number = 0;
  diasdecisor: number = 0;
  diascompliance: number = 0;
  daysreception: string = ''; // deadline of days of reception

  //output betwen brothers
  @Output() investigadoresChanged = new EventEmitter<number>();

  constructor(private apiService: ApiService, private auth: AuthService, private router: Router, private toastr: ToastrService, private translate: TranslateService, private actRoute: ActivatedRoute) { }

  ngOnInit() {
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);

    this.diasinves = Number(localStorage.getItem("diasinves"));
    this.diasdecisor = Number(localStorage.getItem("diasdecisor"));
    this.diascompliance = Number(localStorage.getItem("diascompliance"));
    this.daysreception = localStorage.getItem("daysreception");

    this.validatingForm = new FormGroup({
      investigador: new FormControl('', []),
      plazoFaseInvestigacion: new FormControl('', [
        Validators.required
      ]),
      plazoFaseDecisor: new FormControl('', [
        Validators.required
      ]),
      plazoFaseCompliance: new FormControl('', [
        Validators.required
      ]),
    });

    const idDenuncia = this.actRoute.snapshot.paramMap.get('id');

    this.apiService.searchInvesSelect(this.auth.getSociedad(), idDenuncia, "2")
      .pipe(finalize(() => {this.getAvailableInvestigators(); }))
      .subscribe({
        next: (usuarios2) => {
          this.inves_select = usuarios2.data;
        },
        error: () => {
          this.inves_select = [];
        }
      });

    this.apiService.searchPlazosByIdDenuncia(idDenuncia).subscribe((investigator: PlazosDenuncia[]) => {
      this.plazos = investigator;
      if (this.plazos.length > 0 && this.plazos[0].plazo_investigacion !== '0') {
        if (this.plazos[0].id_denuncia != "") {
          this.cargado = true;
          this.plazoFaseInvestigacionF = this.plazos[0].plazo_investigacion;
          this.plazoFaseDecisorF = this.plazos[0].plazo_decisor;
          this.plazoFaseComplianceF = this.plazos[0].plazo_compliance;
        }
      } else {
        this.plazoFaseInvestigacionF = this.diasinves.toString();
        this.plazoFaseDecisorF = this.diasdecisor.toString();
        this.plazoFaseComplianceF = this.diascompliance.toString();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['denuncia'] && this.denuncia) {
      this.investigadoresSeleccionados();
    }
  }

  get investigador() {
    return this.validatingForm.get('investigador');
  }

  get plazoFaseInvestigacion() {
    return this.validatingForm.get('plazoFaseInvestigacion');
  }

  get plazoFaseDecisor() {
    return this.validatingForm.get('plazoFaseDecisor');
  }

  get plazoFaseCompliance() {
    return this.validatingForm.get('plazoFaseCompliance');
  }

  addInvestigator() {
    if (this.plazoFaseInvestigacion.value == "" || this.plazoFaseDecisor.value == "" || this.plazoFaseCompliance.value == "" || this.investigador.value == "") {
      this.toastr.error(this.translate.instant('texto_323'), this.translate.instant('texto_274'));
    } else {
      this.apiService.createDeadlinesByIdComplaint(this.auth.getSociedad(), this.denuncia[0].id_denuncia, this.plazoFaseInvestigacion.value, this.plazoFaseDecisor.value, this.plazoFaseCompliance.value, this.daysreception, this.investigador.value).subscribe(
        res => {
          if (res == 200) {
            this.toastr.success(this.translate.instant('texto_325'), this.translate.instant('texto_326'));
            this.apiService.createUserByIdComplaint(this.auth.getSociedad(), this.investigador.value, this.denuncia[0].id_denuncia, "1", '1', '1', true).subscribe(
              res => {
                if (res == 200) {
                  this.toastr.success(this.translate.instant('texto_273'), this.translate.instant('texto_274'));
                } else {
                  this.toastr.error(this.translate.instant('texto_327'), this.translate.instant('texto_274'));
                }
              },
              err => {
                this.toastr.error(this.translate.instant('texto_327'), this.translate.instant('texto_274'));
              });
          } else {
            this.toastr.error(this.translate.instant('texto_465'), this.translate.instant('texto_326'));
          }
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
          });
        });
    }

  }

  investigadoresSeleccionados() {
    this.apiService.searchInvesSelect(this.auth.getSociedad(), this.denuncia[0].id_denuncia, "2").subscribe({
      next: (usuarios2) => {
        this.inves_select = usuarios2.data;
        this.investigadoresChanged.emit(this.inves_select.length);
      }, error: (err) => {
        this.inves_select = [];
        this.investigadoresChanged.emit(this.inves_select.length);
      }
    });
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  deleteinves(id_user: string) {
    this.apiService.countInvesSelect(this.auth.getSociedad(), this.denuncia[0].id_denuncia, id_user, "2").subscribe(
      res => {
        if (res == 200) {
          this.apiService.deleteInvesSelect(id_user, this.auth.getSociedad(), this.denuncia[0].id_denuncia, "2").subscribe(
            res => {
              if (res == 200) {
                this.toastr.success(this.translate.instant('texto_462'), this.translate.instant('texto_463'));
              } else {
                this.toastr.error(this.translate.instant('texto_464'), this.translate.instant('texto_463'));
              }
              this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
                this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
              });
            });
        } else {
          this.toastr.error(this.translate.instant('texto_464'), this.translate.instant('texto_463'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
        });
      });
  }

  checkInvesAvailability() {
    if (this.investigadores == null || this.investigadores.length == 0) {
      this.toastr.error(this.translate.instant('texto_932'));
    }
  }
  getAvailableInvestigators() {
    // get investigadores
    this.apiService.searchUserByIdSocietyRole(this.auth.getSociedad(), "2", false, "nulo").subscribe({
      next: (response: any) => {
        const list = response || [];
        const rejectReceptor = this.denuncia?.[0]?.id_receptor_rechazado || null;
        const selectedIds = this.inves_select?.map((u: any) => String(u.id_user ?? "")) || [];

        // get compliance assigned user(s) to identify rejected users
        this.apiService.searchUserComplianceByIdSocietyRole(this.auth.getSociedad(), this.denuncia[0].id_denuncia).subscribe({
          next: (compResp: any) => {
            const rawCompReject = compResp?.[0]?.id_usuario_comp_rechazado || null;
            const compRejectIds = rawCompReject ? rawCompReject.split(",").map((s: any) => s.trim()).filter((s: any) => s) : [];

            this.investigadores = list.filter((d: any) => {
              const uid = String(d.id_user ?? "");
              return uid !== String(rejectReceptor) && !compRejectIds.includes(uid) && !selectedIds.includes(uid);
            });
          },

          error: () => {
            this.investigadores = list.filter((d: any) => {
              const uid = String(d.id_user ?? "");
              return uid !== String(rejectReceptor) && !selectedIds.includes(uid);
            });
          }
        });
      },

      error: () => {
        this.investigadores = [];
        this.toastr.error(this.translate.instant('texto_890'));
      }
    });
  }

}


